import { __assign } from "tslib";
import { useEffect } from 'react';
import { Track } from './Track';
import { TrackError } from './TrackingFunctions';
import { getByIdentifier } from './utils';
export function useCDNTrackingToRat(_a) {
    var isLoading = _a.isLoading, data = _a.data, version = _a.version, projectKey = _a.projectKey, error = _a.error, ratAccountId = _a.ratAccountId, ratServiceType = _a.ratServiceType, ratServiceId = _a.ratServiceId, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, clientId = _a.clientId, _b = _a.isRatCoreEventsOnly, isRatCoreEventsOnly = _b === void 0 ? false : _b, ratApiAccountSrc = _a.ratApiAccountSrc, _c = _a.isPreview, isPreview = _c === void 0 ? false : _c;
    var CDNTrackingParameters = {
        version: version,
        projectKey: projectKey,
        data: data,
        ratAccountId: ratAccountId,
        ratServiceType: ratServiceType,
        ratServiceId: ratServiceId,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        clientId: clientId,
        ratApiAccountSrc: ratApiAccountSrc,
        isRatCoreEventsOnly: isRatCoreEventsOnly,
        isPreview: isPreview,
    };
    useEffect(function () {
        var isError = !isLoading && error;
        var isData = !isLoading && !error && data.length > 0;
        var isEmpty = !isLoading && !error && data.length === 0;
        if (isLoading) {
            Track(__assign({ screen: 'CDN', action: 'FETCH' }, CDNTrackingParameters));
        }
        if (isError) {
            TrackError(__assign({ screen: 'CDN', action: 'ERROR', error: error }, CDNTrackingParameters));
        }
        if (isData) {
            Track(__assign({ screen: 'CDN', action: 'SUCCESS', campaignId: getByIdentifier('campaignId', data), correlationId: getByIdentifier('correlationId', data) }, CDNTrackingParameters));
        }
        if (isEmpty) {
            Track(__assign({ screen: 'CDN', action: 'NO_RESPONSE' }, CDNTrackingParameters));
        }
    }, [isLoading, error]);
}
